export const UNSUBSCRIBED = 'unsubscribed';
export const UNSUBSCRIBED_FILTER_STATE = {
  OFF: 'off',
  ON: 'on',
};
